/* BEWARE OFFICIAL — Theme JS */

(function() {
  'use strict';

  /* Header scroll effect */
  const header = document.querySelector('.site-header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (y > 50) { header.classList.add('scrolled'); }
      else { header.classList.remove('scrolled'); }
      lastScroll = y;
    }, { passive: true });
  }

  /* Mobile menu */
  const toggle = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.header-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      nav.classList.toggle('open');
      toggle.classList.toggle('active');
    });
  }

  /* Scroll reveal */
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    reveals.forEach(el => observer.observe(el));
  }

  /* Quantity selectors */
  document.querySelectorAll('.qty-selector').forEach(sel => {
    const minus = sel.querySelector('[data-qty="minus"]');
    const plus = sel.querySelector('[data-qty="plus"]');
    const input = sel.querySelector('input');
    if (minus && plus && input) {
      minus.addEventListener('click', () => {
        const v = parseInt(input.value) || 1;
        if (v > 1) input.value = v - 1;
      });
      plus.addEventListener('click', () => {
        input.value = (parseInt(input.value) || 0) + 1;
      });
    }
  });

  /* Smooth scroll for anchor links */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
})();
